import AgyleDialog from '../../../../components/modal/agyleDialog';
import PatientContextScheduler from './scheduler';

const SchedulerModal = ({open, onClose, patient, setSchedulerHour}) => {

    return (
        <AgyleDialog
            open={open}
            onClose={onClose}
            fullScreen
            disableSave
            title={`Scheduler for patient ${patient?.patient?.firstName || 'UNK'} ${patient?.patient?.familyName || 'UNK'}`}
            closeButtonOnHeader
        >
            <PatientContextScheduler patient={patient} closeModal={onClose} setSchedulerHour={setSchedulerHour} fromDischarge/>
        </AgyleDialog>
    );
};

export default SchedulerModal;